import { GET_CTO_SWEEP } from "../types";

const initialState = {
  ctoSweepData: [],
};

const ctoSweepReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CTO_SWEEP:
      return {
        ...state,
        ctoSweepData: action.payload || [],
      };
    default:
      return state;
  }
};

export default ctoSweepReducer;
